import angular from 'angular';
import LoginController from "./form.controller";
import LogoutController from "./logout.controller";
import ForgottenPasswordController from "./forgotten-password.controller";
import FetchForgottenPasswordFormService from "../password/fetch-forgotten-password-form.service";

let login = angular
    .module('login', [])
    .controller('LoginController', LoginController)
    .controller('LogoutController', LogoutController)
    .controller('ForgottenPasswordController', ForgottenPasswordController)
    .service('FetchForgottenPasswordFormService', FetchForgottenPasswordFormService);

export default login;


